import * as turf from '@turf/turf';
import getPilotApiService from '../api_services/PilotApiService';
import { Site } from '../types';

// If for whatever reason we were not able to determine the site timezone, we will default to the U.S. Central Time.
// We are not using the uploader's timezone, because GIS/Panomen oftentimes upload photos from Europe and Asia,
// which can shift uploads by a day.
const DEFAULT_TIMEZONE = 'America/Chicago';

const cachedResults = new Map<string, string>();

export const getTimezoneFromCoordinates = async (siteId: string, boundary: Site['boundary'] | null) => {
  if (!boundary?.geometry) {
    console.error(
      `Failed to determine the ${siteId} timezone due to a missing boundary, defaulting to ${DEFAULT_TIMEZONE}`,
    );
    return DEFAULT_TIMEZONE;
  }

  const centroid = turf.centroid(boundary);
  const coordinates = centroid.geometry.coordinates;

  const [lng, lat] = coordinates;
  const key = `${lat}-${lng}`;

  const cachedResult = cachedResults.get(key);
  if (cachedResult !== undefined) {
    return cachedResult;
  }

  try {
    let [timezone] = await getPilotApiService().getTimezoneFromCoordinates({ lat, lng });
    if (!timezone) {
      console.error(`Failed to determine the ${siteId} timezone, defaulting to ${DEFAULT_TIMEZONE}`);
      timezone = DEFAULT_TIMEZONE;
    }
    cachedResults.set(key, timezone);
    return timezone;
  } catch {
    console.error(`Failed to determine the ${siteId} timezone, defaulting to ${DEFAULT_TIMEZONE}`);
    return DEFAULT_TIMEZONE;
  }
};
